var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _g2, _path9, _path10, _path11, _path12, _path13, _path14, _g3, _path15, _path16, _path17, _path18, _path19, _path20, _g4, _path21, _path22, _path23, _path24, _path25, _path26, _g5, _path27, _path28, _path29, _path30, _path31, _path32, _g6, _path33, _path34, _path35, _path36, _path37, _path38, _g7, _path39, _path40, _path41, _path42, _path43, _path44, _g8, _path45, _path46, _path47, _path48, _path49, _path50, _g9, _path51, _path52, _path53, _path54, _path55, _path56, _g10, _path57, _path58, _path59, _path60, _path61, _path62, _g11, _path63, _path64, _path65, _path66, _path67, _path68, _g12, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _g13, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _g14, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _g15, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _g16, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _g17, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _g18, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgService(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 339,
    viewBox: "0 0 351 339",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.884 69.082H44.9131V129.9H111.884V69.082Z",
    fill: "#FFAE0A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1953_10436",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 69,
    width: 68,
    height: 61
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.883 69.083H44.9128V129.901H111.883V69.083Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1953_10436)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M111.883 69.083H44.9128V129.901H111.883V69.083Z",
    fill: "black"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6378 69.082H44.9131V129.9H92.6378V69.082Z",
    fill: "#FFAE0A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6181 69.082H63.3635V86.0586H73.6181V69.082Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1227 91.0186H76.2383V97.0855H88.1227V91.0186Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6827 112.627L70.4348 109.596L68.6289 116.893L80.8768 119.924L82.6827 112.627Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M161.792 69.082H94.8213V129.9H161.792V69.082Z",
    fill: "#FFAE0A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1953_10436",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 94,
    y: 69,
    width: 68,
    height: 61
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M161.792 69.083H94.8213V129.901H161.792V69.083Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1953_10436)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M161.792 69.083H94.8213V129.901H161.792V69.083Z",
    fill: "black"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M142.546 69.082H94.8213V129.9H142.546V69.082Z",
    fill: "#FFAE0A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M123.526 69.082H113.271V86.0586H123.526V69.082Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M138.031 91.0186H126.146V97.0855H138.031V91.0186Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M132.588 112.631L120.34 109.6L118.534 116.897L130.782 119.928L132.588 112.631Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M211.7 69.082H144.729V129.9H211.7V69.082Z",
    fill: "#FFAE0A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1953_10436",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 69,
    width: 68,
    height: 61
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M211.7 69.083H144.729V129.901H211.7V69.083Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1953_10436)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M211.7 69.083H144.729V129.901H211.7V69.083Z",
    fill: "black"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M192.454 69.082H144.729V129.9H192.454V69.082Z",
    fill: "#FFAE0A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M173.434 69.082H163.18V86.0586H173.434V69.082Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M187.939 91.0186H176.054V97.0855H187.939V91.0186Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M182.493 112.634L170.245 109.603L168.439 116.9L180.687 119.931L182.493 112.634Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M261.608 69.082H194.638V129.9H261.608V69.082Z",
    fill: "#FFAE0A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1953_10436",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 194,
    y: 69,
    width: 68,
    height: 61
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M261.608 69.083H194.638V129.901H261.608V69.083Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1953_10436)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M261.608 69.083H194.638V129.901H261.608V69.083Z",
    fill: "black"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M242.362 69.082H194.638V129.9H242.362V69.082Z",
    fill: "#FFAE0A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M223.342 69.082H213.088V86.0586H223.342V69.082Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M237.847 91.0186H225.963V97.0855H237.847V91.0186Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M232.405 112.637L220.157 109.606L218.351 116.904L230.599 119.935L232.405 112.637Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M111.884 152.522H44.9131V213.34H111.884V152.522Z",
    fill: "#FFAE0A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1953_10436",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 152,
    width: 68,
    height: 62
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M111.884 152.522H44.9131V213.34H111.884V152.522Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1953_10436)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M111.884 152.522H44.9131V213.34H111.884V152.522Z",
    fill: "black"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6378 152.522H44.9131V213.34H92.6378V152.522Z",
    fill: "#FFAE0A"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6181 152.522H63.3635V169.499H73.6181V152.522Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1227 174.459H76.2383V180.526H88.1227V174.459Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6715 196.064L70.4236 193.033L68.6177 200.33L80.8656 203.362L82.6715 196.064Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M161.792 152.522H94.8213V213.34H161.792V152.522Z",
    fill: "#FFAE0A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1953_10436",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 94,
    y: 152,
    width: 68,
    height: 62
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M161.792 152.522H94.8213V213.34H161.792V152.522Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1953_10436)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M161.792 152.522H94.8213V213.34H161.792V152.522Z",
    fill: "black"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M142.546 152.522H94.8213V213.34H142.546V152.522Z",
    fill: "#FFAE0A"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M123.526 152.522H113.271V169.499H123.526V152.522Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M138.031 174.459H126.146V180.526H138.031V174.459Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M132.584 196.068L120.336 193.037L118.53 200.334L130.778 203.365L132.584 196.068Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M211.7 152.522H144.729V213.34H211.7V152.522Z",
    fill: "#FFAE0A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1953_10436",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 152,
    width: 68,
    height: 62
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M211.7 152.522H144.729V213.34H211.7V152.522Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1953_10436)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M211.7 152.522H144.729V213.34H211.7V152.522Z",
    fill: "black"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M192.454 152.522H144.729V213.34H192.454V152.522Z",
    fill: "#FFAE0A"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M173.434 152.522H163.18V169.499H173.434V152.522Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M187.939 174.459H176.054V180.526H187.939V174.459Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M182.489 196.072L170.241 193.041L168.435 200.338L180.683 203.369L182.489 196.072Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M261.608 152.522H194.638V213.34H261.608V152.522Z",
    fill: "#FFAE0A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_1953_10436",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 194,
    y: 152,
    width: 68,
    height: 62
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M261.608 152.522H194.638V213.34H261.608V152.522Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_1953_10436)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M261.608 152.522H194.638V213.34H261.608V152.522Z",
    fill: "black"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M242.362 152.522H194.638V213.34H242.362V152.522Z",
    fill: "#FFAE0A"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M223.342 152.522H213.088V169.499H223.342V152.522Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M237.847 174.459H225.963V180.526H237.847V174.459Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M232.394 196.075L220.146 193.044L218.34 200.341L230.588 203.372L232.394 196.075Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M111.884 235.963H44.9131V296.781H111.884V235.963Z",
    fill: "#FFAE0A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_1953_10436",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 235,
    width: 68,
    height: 62
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M111.884 235.963H44.9131V296.781H111.884V235.963Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_1953_10436)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M111.884 235.963H44.9131V296.781H111.884V235.963Z",
    fill: "black"
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6378 235.963H44.9131V296.781H92.6378V235.963Z",
    fill: "#FFAE0A"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6181 235.963H63.3635V252.939H73.6181V235.963Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1227 257.898H76.2383V263.965H88.1227V257.898Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6681 279.502L70.4202 276.471L68.6143 283.768L80.8622 286.799L82.6681 279.502Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M161.792 235.963H94.8213V296.781H161.792V235.963Z",
    fill: "#FFAE0A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_1953_10436",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 94,
    y: 235,
    width: 68,
    height: 62
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M161.792 235.963H94.8213V296.781H161.792V235.963Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_1953_10436)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M161.792 235.963H94.8213V296.781H161.792V235.963Z",
    fill: "black"
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M142.546 235.963H94.8213V296.781H142.546V235.963Z",
    fill: "#FFAE0A"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M123.526 235.963H113.271V252.939H123.526V235.963Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M138.031 257.898H126.146V263.965H138.031V257.898Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M132.581 279.506L120.333 276.475L118.527 283.772L130.775 286.803L132.581 279.506Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M211.7 235.963H144.729V296.781H211.7V235.963Z",
    fill: "#FFAE0A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_1953_10436",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 235,
    width: 68,
    height: 62
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M211.7 235.963H144.729V296.781H211.7V235.963Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_1953_10436)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M211.7 235.963H144.729V296.781H211.7V235.963Z",
    fill: "black"
  }))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M192.454 235.963H144.729V296.781H192.454V235.963Z",
    fill: "#FFAE0A"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M173.434 235.963H163.18V252.939H173.434V235.963Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M187.939 257.898H176.054V263.965H187.939V257.898Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M182.486 279.51L170.238 276.479L168.432 283.776L180.68 286.807L182.486 279.51Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M261.608 235.963H194.638V296.781H261.608V235.963Z",
    fill: "#FFAE0A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_1953_10436",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 194,
    y: 235,
    width: 68,
    height: 62
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M261.608 235.963H194.638V296.781H261.608V235.963Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_1953_10436)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M261.608 235.963H194.638V296.781H261.608V235.963Z",
    fill: "black"
  }))), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M242.362 235.963H194.638V296.781H242.362V235.963Z",
    fill: "#FFAE0A"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M223.342 235.963H213.088V252.939H223.342V235.963Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M237.847 257.898H225.963V263.965H237.847V257.898Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M232.39 279.512L220.143 276.481L218.337 283.779L230.585 286.81L232.39 279.512Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M267.808 46.7324H33.863V57.6498H267.808V46.7324Z",
    fill: "#A3A3A3"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M267.808 127.833H33.863V138.75H267.808V127.833Z",
    fill: "#A3A3A3"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M267.808 208.927H33.863V219.844H267.808V208.927Z",
    fill: "#A3A3A3"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M267.808 290.027H33.863V300.945H267.808V290.027Z",
    fill: "#A3A3A3"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M312.257 0.723633H302.119V332.145H312.257V0.723633Z",
    fill: "#7A7A7A"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2482 0.723633H86.1106V332.145H96.2482V0.723633Z",
    fill: "#7A7A7A"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M309.918 46.7324H262.349V57.6498H309.918V46.7324Z",
    fill: "#757575"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M309.918 127.833H262.349V138.75H309.918V127.833Z",
    fill: "#757575"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M309.918 208.927H262.349V219.844H309.918V208.927Z",
    fill: "#757575"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M309.918 290.027H262.349V300.945H309.918V290.027Z",
    fill: "#757575"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2208 0.723633H33.0833V332.145H43.2208V0.723633Z",
    fill: "#A3A3A3"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M155.514 0.723633H145.377V332.145H155.514V0.723633Z",
    fill: "#A3A3A3"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M267.808 0.723633H257.67V332.145H267.808V0.723633Z",
    fill: "#A3A3A3"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M247.322 115.91H167.765V188.152H247.322V115.91Z",
    fill: "#FFAE0A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_1953_10436",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 167,
    y: 115,
    width: 81,
    height: 74
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M247.322 115.91H167.765V188.152H247.322V115.91Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_1953_10436)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M247.322 115.91H167.765V188.152H247.322V115.91Z",
    fill: "black"
  }))), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M247.322 115.91H167.765V188.152H247.322V115.91Z",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M224.465 115.91H167.765V188.152H224.465V115.91Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M201.858 115.91H189.678V136.076H201.858V115.91Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M219.1 141.964H204.978V149.169H219.1V141.964Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M212.618 167.639L198.069 164.038L195.922 172.713L210.471 176.314L212.618 167.639Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M199.472 259.896H119.916V332.138H199.472V259.896Z",
    fill: "#FFAE0A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_1953_10436",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 119,
    y: 259,
    width: 81,
    height: 74
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M199.472 259.895H119.916V332.137H199.472V259.895Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_1953_10436)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M199.472 259.895H119.916V332.137H199.472V259.895Z",
    fill: "black"
  }))), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M199.472 259.896H119.916V332.138H199.472V259.896Z",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M176.616 259.896H119.916V332.138H176.616V259.896Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M154.009 259.896H141.828V280.061H154.009V259.896Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M139.551 319.099H125.429V326.304H139.551V319.099Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M169.211 285.873L154.662 282.272L152.515 290.947L167.064 294.548L169.211 285.873Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M257.974 259.896H178.417V332.138H257.974V259.896Z",
    fill: "#FFAE0A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_1953_10436",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 178,
    y: 259,
    width: 80,
    height: 74
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M257.974 259.895H178.417V332.137H257.974V259.895Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_1953_10436)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M257.974 259.895H178.417V332.137H257.974V259.895Z",
    fill: "black"
  }))), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M257.974 259.896H178.417V332.138H257.974V259.896Z",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M235.118 259.896H178.417V332.138H235.118V259.896Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M212.511 259.896H200.33V280.061H212.511V259.896Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M229.753 285.956H215.63V293.162H229.753V285.956Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M198.31 280.976L183.761 277.375L181.614 286.05L196.163 289.651L198.31 280.976Z",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M317.24 259.896H237.683V332.138H317.24V259.896Z",
    fill: "#FFAE0A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_1953_10436",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 237,
    y: 259,
    width: 81,
    height: 74
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M317.24 259.895H237.683V332.137H317.24V259.895Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_1953_10436)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M317.24 259.895H237.683V332.137H317.24V259.895Z",
    fill: "black"
  }))), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M317.24 259.896H237.683V332.138H317.24V259.896Z",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M294.383 259.896H237.683V332.138H294.383V259.896Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M271.777 259.896H259.596V280.061H271.777V259.896Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M289.018 285.956H274.896V293.162H289.018V285.956Z",
    fill: "white"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M257.572 280.981L243.023 277.381L240.876 286.056L255.425 289.656L257.572 280.981Z",
    fill: "white"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M226.906 187.848H147.349V260.09H226.906V187.848Z",
    fill: "#FFAE0A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_1953_10436",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 147,
    y: 187,
    width: 80,
    height: 74
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M226.906 187.849H147.35V260.091H226.906V187.849Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_1953_10436)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M226.906 187.849H147.35V260.091H226.906V187.849Z",
    fill: "black"
  }))), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M226.906 187.848H147.349V260.09H226.906V187.848Z",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M204.05 187.848H147.349V260.09H204.05V187.848Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M181.435 187.848H169.254V208.014H181.435V187.848Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M198.685 213.909H184.562V221.115H198.685V213.909Z",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M167.236 208.93L152.687 205.329L150.54 214.004L165.089 217.605L167.236 208.93Z",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M290.071 187.848H210.514V260.09H290.071V187.848Z",
    fill: "#FFAE0A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_1953_10436",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 210,
    y: 187,
    width: 81,
    height: 74
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M290.071 187.849H210.515V260.091H290.071V187.849Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_1953_10436)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M290.071 187.849H210.515V260.091H290.071V187.849Z",
    fill: "black"
  }))), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M290.071 187.848H210.514V260.09H290.071V187.848Z",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M267.215 187.848H210.514V260.09H267.215V187.848Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M244.6 187.848H232.419V208.014H244.6V187.848Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M261.849 213.909H247.727V221.115H261.849V213.909Z",
    fill: "white"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M233.906 226.015L219.357 222.414L217.21 231.089L231.759 234.69L233.906 226.015Z",
    fill: "white"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M8.44092 332.138H350",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1107 308.852C69.1107 308.852 65.8355 315.504 63.496 319.263C61.1566 323.022 56.813 327.966 57.2575 332.317C57.702 336.668 62.2327 337.136 66.896 334.656C71.5593 332.177 75.7547 327.201 77.0336 323.466C78.3125 319.731 82.3207 316.627 82.3207 312.432C82.3207 308.236 82.0088 307.753 80.457 307.301C78.9052 306.848 70.6625 306.209 69.1107 308.852Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3206 312.424C82.3206 311.808 82.3206 311.277 82.3206 310.81C81.8895 312.108 81.3683 313.374 80.761 314.599C79.0454 318.023 76.5578 320.058 75.6298 324.238C74.7018 328.418 68.7908 333.253 63.6597 334.493C58.5285 335.732 57.4211 331.545 57.4211 331.545H57.234C57.215 331.804 57.215 332.065 57.234 332.325C57.7019 336.676 62.2092 337.144 66.8725 334.664C71.5358 332.184 75.7312 327.209 77.0101 323.474C78.289 319.738 82.3206 316.619 82.3206 312.424Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7346 311.645C69.7346 311.645 71.6062 314.288 77.8213 313.516",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5786 313.827C71.4257 315.28 73.7697 315.95 76.1057 315.691",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9548 315.691C69.6412 316.434 70.4934 317.005 71.4421 317.356C72.3907 317.707 73.4089 317.828 74.4135 317.711",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3308 318.335C68.3308 318.335 69.4226 320.511 73.618 320.043",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M108.897 314.724C111.236 318.406 114.451 321.449 118.255 323.583C124.314 326.851 132.089 329.042 132.705 330.601C132.965 331.167 133.014 331.808 132.844 332.407C132.674 333.006 132.295 333.524 131.777 333.869C130.997 334.329 119.495 334.649 113.435 333.557C110.016 332.826 106.52 332.512 103.025 332.621C100.225 332.621 94.1662 333.401 93.3863 329.978C92.6065 326.554 94.6262 314.124 94.6262 314.124C94.6262 314.124 103.766 316.775 108.897 314.724Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeMiterlimit: 10
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M131.745 333.876C132.147 333.611 132.466 333.237 132.664 332.798C132.863 332.36 132.934 331.874 132.868 331.397C130.456 331.985 128.003 332.397 125.53 332.629C119.292 333.253 109.989 331.233 102.682 330.921C97.3167 330.695 94.3846 329.455 93.207 328.823C93.2282 329.214 93.2777 329.602 93.3552 329.985C94.135 333.409 100.194 332.629 102.994 332.629C106.489 332.519 109.985 332.834 113.404 333.565C119.463 334.648 130.966 334.337 131.745 333.876Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeMiterlimit: 10
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M111.229 318.335C110.03 319.292 109.072 320.515 108.429 321.907",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeMiterlimit: 10
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M113.092 320.658C113.092 320.658 111.073 322.374 111.073 323.458",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeMiterlimit: 10
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M115.112 322.218C114.589 323.098 114.173 324.038 113.872 325.017",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeMiterlimit: 10
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M118.223 323.614C118.223 323.614 116.976 324.706 116.976 325.79",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeMiterlimit: 10
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0011 149.661C65.0011 149.661 60.057 173.188 60.447 186.055C60.8369 198.922 78.3827 230.894 78.3827 230.894C78.3827 230.894 69.0249 253.899 68.635 264.037C68.2451 274.174 69.0405 306.809 69.0405 306.809C69.0405 306.809 72.9396 309.071 76.4722 309.071C80.0047 309.071 84.2235 307.293 84.2235 307.293L93.1992 272.201L93.5891 314.701C96.1855 316.239 99.1492 317.048 102.167 317.041C105.237 317.022 108.229 316.07 110.745 314.311C110.745 314.311 116.984 269.472 117.763 262.064C118.543 254.655 123.612 232.431 124.002 230.871C124.392 229.311 131.8 204.747 131.8 184.862C131.8 164.977 126.084 153.022 126.084 153.022C126.084 153.022 106.066 148.601 91.2497 148.211C82.4751 147.969 73.6956 148.454 65.0011 149.661Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9285 266.376C95.9285 266.376 106.066 237.523 106.066 230.504C106.066 223.486 99.4376 179.816 99.4376 179.816",
    stroke: "#878787",
    strokeWidth: 0.389907,
    strokeMiterlimit: 10
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M102.167 193.073C102.167 193.073 108.016 186.445 109.965 182.546",
    stroke: "#878787",
    strokeWidth: 0.389907,
    strokeMiterlimit: 10
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M125.304 89.8804C125.304 89.8804 133.36 94.5593 137.781 101.578C142.203 108.596 151.818 138.229 151.295 145.762C150.773 153.295 148.441 155.385 141.68 154.082C134.919 152.78 134.405 145.247 132.845 139.009C131.285 132.77 122.965 93.257 122.965 93.257L122.707 89.6152L125.304 89.8804Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M151.295 145.762C151.561 141.925 149.198 132.349 146.227 122.952L129.78 125.229C131.161 131.624 132.346 136.997 132.845 138.985C134.405 145.224 134.919 152.757 141.68 154.059C148.441 155.361 150.781 153.303 151.295 145.762Z",
    fill: "#CFCFCF",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4968 87.541C71.4968 87.541 65.2583 88.8355 63.6986 99.7529C62.139 110.67 65.7808 128.606 65.7808 128.606L65.0009 149.661C65.0009 149.661 90.9922 156.422 101.652 156.422C112.312 156.422 126.084 153.045 126.084 153.045C126.084 153.045 120.368 100.533 119.323 96.1189C118.278 91.7052 113.607 87.2758 109.708 84.4217C105.809 81.5676 95.9284 81.8171 90.2124 83.3768C84.4963 84.9364 76.433 88.0556 76.433 88.0556L71.4968 87.541Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2124 80.2578C90.2124 80.2578 95.6711 102.358 96.1936 117.432C96.7161 132.505 93.8542 179.294 93.8542 179.294C93.8542 179.294 81.6345 179.817 72.7992 178.257C63.9639 176.697 57.7175 175.918 57.7175 175.918L65.5157 127.312C65.5157 127.312 76.1758 128.092 78.5152 120.551C80.8546 113.01 77.7354 97.9362 74.8735 93.2573C72.0115 88.5784 71.4969 87.5413 71.4969 87.5413L90.2124 80.2578Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M113.864 100.798C113.864 100.798 119.588 122.633 119.065 144.468C118.543 166.302 118.286 178 118.286 178C118.286 178 130.763 177.22 137.781 174.358C137.781 174.358 133.882 123.413 130.24 108.331C126.599 93.2494 125.304 89.8806 125.304 89.8806L110.745 83.8994L113.864 100.798Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8116 76.0155C95.8116 76.0155 90.3529 77.0293 88.918 79.8678C87.4831 82.7063 94.5951 106.023 94.5951 106.023L104.935 97.5072L117.709 104.806C117.709 104.806 115.276 87.1669 110.004 81.0843C104.733 75.0017 95.8116 76.0155 95.8116 76.0155Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5812 61.2217C93.5812 61.2217 93.3785 81.6918 95.6087 86.9556C97.839 92.2193 103.719 99.9317 105.949 98.7152C108.179 97.4986 108.788 82.6978 109.193 81.684C109.599 80.6703 111.221 72.3262 111.221 72.3262C111.221 72.3262 96.6225 68.3024 93.5812 61.2217Z",
    fill: "#CFCFCF",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5812 61.2217C93.5812 61.2217 93.5032 69.4409 94.0101 76.818C96.3368 79.5733 99.6061 81.3636 103.181 81.84C105.171 82.1412 107.196 82.1149 109.178 81.762C109.174 81.7439 109.174 81.7254 109.178 81.7074C109.583 80.6936 111.205 72.3496 111.205 72.3496C111.205 72.3496 96.6225 68.3024 93.5812 61.2217Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M116.391 131.655L114.831 132.606L105.809 117.86C105.685 117.654 105.647 117.407 105.704 117.173C105.761 116.94 105.908 116.738 106.113 116.612C106.214 116.549 106.327 116.507 106.445 116.488C106.562 116.469 106.682 116.474 106.798 116.501C106.914 116.529 107.024 116.579 107.12 116.649C107.217 116.719 107.298 116.807 107.361 116.909L116.391 131.655Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4969 87.541C71.4969 87.541 65.5157 88.0557 61.8818 95.074C58.2478 102.092 52.524 135.11 51.4791 144.725C50.4341 154.34 56.1579 153.56 56.9378 153.56C57.7176 153.56 99.0478 139.789 99.0478 139.789L113.084 138.229C113.084 138.229 111.525 139.523 112.827 139.523C114.129 139.523 116.726 136.927 117.763 135.367C118.8 133.807 114.644 125.229 113.084 124.192C111.525 123.155 97.4881 133.55 97.4881 133.55L70.1946 135.367L77.2129 111.45",
    fill: "white"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4969 87.541C71.4969 87.541 65.5157 88.0557 61.8818 95.074C58.2478 102.092 52.524 135.11 51.4791 144.725C50.4341 154.34 56.1579 153.56 56.9378 153.56C57.7176 153.56 99.0478 139.789 99.0478 139.789L113.084 138.229C113.084 138.229 111.525 139.523 112.827 139.523C114.129 139.523 116.726 136.927 117.763 135.367C118.8 133.807 114.644 125.229 113.084 124.192C111.525 123.155 97.4881 133.55 97.4881 133.55L70.1946 135.367L77.2129 111.45",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M113.085 124.192C111.525 123.147 97.4882 133.55 97.4882 133.55L70.1947 135.367L71.9259 129.471L54.4658 125.533C53.0232 133.542 51.8924 140.942 51.4791 144.724C50.442 154.34 56.158 153.56 56.9378 153.56C57.7176 153.56 99.0478 139.788 99.0478 139.788L113.085 138.229C113.085 138.229 111.525 139.523 112.827 139.523C114.129 139.523 116.726 136.926 117.763 135.367C118.801 133.807 114.644 125.229 113.085 124.192Z",
    fill: "#CFCFCF",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M113.084 124.192C111.525 123.147 97.4881 133.55 97.4881 133.55L93.511 133.815C93.4958 136.332 94.1153 138.813 95.3124 141.028L99.0477 139.788L113.084 138.229C113.084 138.229 111.525 139.523 112.827 139.523C114.129 139.523 116.726 136.926 117.763 135.367C118.8 133.807 114.644 125.229 113.084 124.192Z",
    fill: "#666666",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M126.864 111.973L100.35 149.146L135.184 147.844L160.396 113.532L126.864 111.973Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M138.569 110.881L136.533 114.265L151.779 114.608L153.814 111.216L138.569 110.881Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M148.87 133.066C147.673 133.504 146.426 133.792 145.158 133.924C143.599 133.994 142.164 134.782 142.164 135.569C142.164 136.357 144.948 136.497 146.944 136.497C148.94 136.497 150.508 136.068 150.843 134.782C151.178 133.495 150.726 132.356 148.87 133.066Z",
    fill: "#666666",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M150.664 129.581C149.154 130.134 147.583 130.501 145.985 130.673C143.996 130.759 142.187 131.757 142.187 132.747C142.187 133.738 145.712 133.925 148.246 133.925C150.781 133.925 152.769 133.387 153.222 131.757C153.674 130.127 153.019 128.677 150.664 129.581Z",
    fill: "#666666",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M152.106 126.602C150.597 127.155 149.026 127.521 147.428 127.694C145.431 127.779 143.622 128.777 143.622 129.768C143.622 130.758 147.155 130.945 149.689 130.945C152.223 130.945 154.212 130.407 154.664 128.777C155.117 127.148 154.462 125.697 152.106 126.602Z",
    fill: "#666666",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M153.081 123.233C151.571 123.782 150 124.145 148.402 124.316C146.414 124.402 144.604 125.4 144.604 126.399C144.604 127.397 148.129 127.576 150.664 127.576C153.198 127.576 155.187 127.03 155.639 125.4C156.091 123.771 155.436 122.328 153.081 123.233Z",
    fill: "#666666",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2372 299.378C68.2372 299.378 68.0735 307.457 68.3932 308.736C68.7129 310.015 74.3744 311.637 77.9225 311.637C81.4707 311.637 83.74 310.857 84.3872 309.866C85.0345 308.876 86.1574 302.271 86.1574 302.271C86.1574 302.271 73.5634 304.876 68.2372 299.378Z",
    fill: "#666666",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1107 54.7337C83.5827 53.8434 80.8643 53.637 78.2309 54.1354C75.5974 54.6339 73.1425 55.8196 71.1148 57.5723C64.0185 63.6548 70.335 74.6034 77.8057 75.8199C85.2763 77.0364 90.1657 73.5897 91.3822 68.1154C92.5987 62.6411 90.5868 54.531 86.1107 54.7337Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M121.982 52.9096C121.982 52.9096 120.968 63.0472 118.941 70.1435C116.913 77.2398 111.642 79.8756 104.124 78.8618C96.6069 77.8481 92.3647 71.7655 89.9317 64.6692C87.4986 57.5729 87.2959 47.8408 87.2959 47.8408L121.982 52.9096Z",
    fill: "#CFCFCF",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3565 52.7063C88.3565 52.7063 90.7895 54.9366 96.2482 51.0843C101.707 47.232 99.0867 45.4072 99.0867 45.4072L86.1106 46.187L88.3565 52.7063Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M113.903 55.3418C113.903 55.3418 112.889 58.3831 113.498 59.3968C114.106 60.4106 115.728 61.8299 113.903 63.4519C113.573 63.7746 113.171 64.015 112.73 64.1533C112.289 64.2917 111.822 64.3242 111.366 64.2483C110.91 64.1723 110.479 63.99 110.107 63.7162C109.735 63.4423 109.432 63.0846 109.224 62.6721",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M102.596 64.4033C102.596 64.4033 105.715 68.4506 111.626 66.5868",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M107.01 56.5588C107.01 57.6817 106.557 58.5863 105.996 58.5863C105.434 58.5863 104.982 57.6817 104.982 56.5588C104.982 55.4358 105.434 54.5312 105.996 54.5312C106.557 54.5312 107.01 55.4358 107.01 56.5588Z",
    fill: "#263238"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M118.161 58.1652C118.161 59.2881 117.709 60.1927 117.147 60.1927C116.586 60.1927 116.134 59.2881 116.134 58.1652C116.134 57.0423 116.586 56.1377 117.147 56.1377C117.709 56.1377 118.161 57.0579 118.161 58.1652Z",
    fill: "#263238"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M102.752 52.098C102.752 52.098 105.59 48.854 109.24 52.098",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M115.744 53.7198C116.368 53.2589 117.133 53.0274 117.909 53.0644C118.684 53.1013 119.423 53.4044 120.001 53.9225",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3308 48.6516L123.043 52.7066C123.043 52.7066 122.637 33.648 122.434 30.4117C122.232 27.1755 107.228 22.7072 101.379 23.1127C95.5308 23.5182 88.2005 26.965 86.984 28.5714C85.7675 30.1778 85.3308 48.6516 85.3308 48.6516Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M101.535 50.6788L134.982 55.1394C134.982 55.1394 126.068 47.4348 118.972 46.8265C111.876 46.2183 101.535 50.6788 101.535 50.6788Z",
    fill: "#FFAE0A",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7759 54.1261C89.7759 54.1261 88.996 47.8408 85.5181 47.8408C82.0401 47.8408 83.6933 52.9096 84.0988 56.1536C84.5043 59.3977 88.3566 60.2087 89.7759 58.9922",
    fill: "#CFCFCF"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7759 54.1261C89.7759 54.1261 88.996 47.8408 85.5181 47.8408C82.0401 47.8408 83.6933 52.9096 84.0988 56.1536C84.5043 59.3977 88.3566 60.2087 89.7759 58.9922",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2693 307.776L93.7528 315.372C93.7528 315.372 95.8973 316.978 102.167 317.064C108.437 317.15 110.745 314.335 110.745 314.335L112 306.146C112 306.146 100.373 311.652 93.2693 307.776Z",
    fill: "#666666",
    stroke: "#263238",
    strokeWidth: 0.389907,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgService);
export default __webpack_public_path__ + "static/media/service__.6a40cce541db35bfe50ca80d98f3446f.svg";
export { ForwardRef as ReactComponent };